import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import icStar from '@iconify/icons-ic/twotone-star';
import icMoreVert from '@iconify/icons-ic/twotone-more-vert';
import icClose from '@iconify/icons-ic/twotone-close';
import icPrint from '@iconify/icons-ic/twotone-print';
import icDownload from '@iconify/icons-ic/twotone-cloud-download';
import icDelete from '@iconify/icons-ic/twotone-delete';
import icBusiness from '@iconify/icons-ic/twotone-business';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icEmail from '@iconify/icons-ic/twotone-mail';
import icPerson from '@iconify/icons-ic/twotone-person';
import icStarBorder from '@iconify/icons-ic/twotone-star-border';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from 'src/app/services/loading.service';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users.service';
import { MustMatch } from 'src/app/shared/validator/must-match.validator';
import { SessionLoginComponent } from '../../session-login/session-login.component';


@Component({
  selector: 'vex-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    },
  ],

})
export class ChangePasswordComponent implements OnInit {
  
  form: FormGroup;
  oldInputType = 'password';
  newInputType = 'password';
  cpInputType = 'password';
  icClose = icClose;
  oldPassword = new FormControl('', [Validators.required]);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private loadingService: LoadingService,
    private snackbar: MatSnackBar,
    private userService: UsersService
  ) {
    this.dialogRef.disableClose = true
  }

  

  ngOnInit(): void {
    this.intializeform()

  }

  intializeform() {
    this.form = this.fb.group({
      // '^(?=[^A-Za-z]*[A-Za-z])(?=\\D*\\d)(?=[^!@#\\$%\\^\\&*\\)\\(+=_-]*[!@#\\$%\\^\\&*\\)\\(+=_-])[A-Za-z\\d!@#\\$%\\^\\&*\\)\\(+=_-]{8,}$'
      newPassword: new FormControl('',  [Validators.required , Validators.pattern('^(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])(?=\\D*\\d)(?=[^!@#\\$%\\^\\&*\\)\\(+=_-]*[!@#\\$%\\^\\&*\\)\\(+=_-])[A-Za-z\\d!@#\\$%\\^\\&*\\)\\(+=_-]{8,}$')] ),
      reEnterPassword: new FormControl('', [Validators.required])
     },
     { validator: MustMatch('newPassword', 'reEnterPassword') }
     );
  }

  
  checkWhitSpaces(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 32) {
      return false;
    }
    return true;
  }

  showLoginPopup(){
    let url = location.href;
    if(localStorage.getItem('user_session_id')){
      this.userService.removeUserLocalStorage();
    }
    this.dialog.open(SessionLoginComponent, {
      data: {url:url},
      width: 'auto',
      height: 'auto',
      minWidth: '500px'
    }).afterClosed().subscribe(item => {
      //console.log(item);
      if(item === 'yes'){
        
      }
      
      
    })
  }

  changePassword() {
    //console.log("the change password")
    if(this.form.valid && this.oldPassword.valid){
      this.loadingService.showLoader()
      const data = {
        current_password: this.oldPassword.value,
        new_password: this.form.controls.newPassword.value
      }

      this.userService.resetPassword(data).subscribe((response) => {
        this.loadingService.hideLoader()
        //console.log(response)
        if(response.error){
          this.snackbar.open(response.error,'',{
            duration:3000
          })
        }else {
          this.snackbar.open(response.message,'',{
            duration:3000
          })

          this.dialogRef.close()
        }
       
        
      },(error) => {
        this.loadingService.hideLoader()
        if(error.server_error_code === 'sessionExpired'){
          this.snackbar.open('Session Expired, Please Login and Try again','',{
            duration:3000
          })
            this.showLoginPopup()            
          
        }else{
          this.snackbar.open('Something went wrong, Try again','',{
            duration:3000
          })
        }
        //console.log(error)
      })
    }

   
  }

}
